import React from 'react';
import Img from '../../../../../../components/Img/Img';
import { TAG_DETAIL_PAGE_LAYOUT_TYPE } from '../../../../../../constants/service/app/tagConstants';
import feedToggleOffBtn from '../../../../../../static/images/tag/tagDetailPreview/feed-toggle-off-btn.png';
import feedToggleOnBtn from '../../../../../../static/images/tag/tagDetailPreview/feed-toggle-on-btn.png';
import galleryToggleOffBtn from '../../../../../../static/images/tag/tagDetailPreview/gallery-toggle-off-btn.png';
import galleryToggleOnBtn from '../../../../../../static/images/tag/tagDetailPreview/gallery-toggle-on-btn.png';
import './TagPreviewDetailPageBottom.scss';

const TagPreviewDetailPageBottom = (props) => {
  const { tagDetailLayoutType, changeTagDetailLayoutType } = props;

  return (
    <div className="tag-preview-main-detail-page-bottom">
      <div className="tag-detail-layout-toggle-button">
        <Img
          clickAble={false}
          src={tagDetailLayoutType === TAG_DETAIL_PAGE_LAYOUT_TYPE.GALLERY ? galleryToggleOnBtn : galleryToggleOffBtn}
          onClick={() => changeTagDetailLayoutType(TAG_DETAIL_PAGE_LAYOUT_TYPE.GALLERY)}
        />

        <div className="bar" />

        <Img
          clickAble={false}
          src={tagDetailLayoutType === TAG_DETAIL_PAGE_LAYOUT_TYPE.FEED ? feedToggleOnBtn : feedToggleOffBtn}
          onClick={() => changeTagDetailLayoutType(TAG_DETAIL_PAGE_LAYOUT_TYPE.FEED)}
        />
      </div>

      <div className="following-button">팔로우</div>
    </div>
  );
};

export default TagPreviewDetailPageBottom;
